export function formatAddress(addL1: string, addL2: string, city: string, state: string, zip: string, country?: string) {
  let formattedcountry = country === undefined || country === null || country === '' ? '' : `${', ' + country}`;
  let formattedCityState = `${city}, ${state}`;
  if ((city === undefined || city === null || city === '') && (state === undefined || state === null || state === '')) {
    formattedCityState = '';
  }
  if ((zip === undefined || zip === null || zip === '') && (city === undefined || city === null || city === '') && (state === undefined || state === null || state === '')) {
    formattedcountry = '-';
  }
  const addr = [];
  addr.push(addL1 ? `${addL1}\n` : '');
  addr.push(addL2 ? `${addL2}\n` : '');
  addr.push(`${formattedCityState} ${zip}${formattedcountry}`);
  return addr.join('');
}
